import { connect } from 'react-redux';
import { createWorklistView } from './worklist-actions';
import CreateView from '../components/toolbar/create-view-sidepanel';

const mapStateToProps = state => ({
  isSaving: state.worklist.isSavingViews,
  saveSuccess: state.worklist.saveViewsSuccess,
  error: state.worklist.error,
  defaultExpanded: state.worklist.defaultExpanded,
});

const mapDispatchToProps = {
  createView: createWorklistView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateView);
